export const QUESTIONNAIRES_LOADED = 'QUESTIONNAIRES_LOADED';
export const NEW_QUESTIONNAIRES_COUNT_LOADED = 'NEW_QUESTIONNAIRES_COUNT_LOADED';
export const QUESTIONNARE_DETAILS_LOADED = 'QUESTIONNARE_DETAILS_LOADED';
export const QUESTIONNAIRE_SELECTED = 'QUESTIONNAIRE_SELECTED';
export const QUESTIONNAIRE_ANSWER_UPDATED = 'QUESTIONNAIRE_ANSWER_UPDATED';
export const QUESTIONNAIRE_SUBMITTED = 'QUESTIONNAIRE_SUBMITTED';
export const QUESTIONNAIRE_VALIDATED = 'QUESTIONNAIRE_VALIDATED';
export const QUESTIONNAIRE_ANSWERSCLEARED = 'QUESTIONNAIRE_ANSWERSCLEARED';
export const QUESTIONNAIRE_SET_FILTER = 'QUESTIONNAIRE_SET_FILTER';
export const HISTORICAL_QUESTIONNAIRES_LOADED = 'HISTORICAL_QUESTIONNAIRES_LOADED';
export const HISTORICAL_QUESTIONNARE_DETAILS_LOADED = 'HISTORICAL_QUESTIONNARE_DETAILS_LOADED';
export const KIOSK_QUESTIONNAIRES_LOADED = 'KIOSK_QUESTIONNAIRES_LOADED';
export const KIOSK_QUESTIONNAIRES_FAILED = 'KIOSK_QUESTIONNAIRES_FAILED';
export const QUESTIONNAIRES_ORIGIN_UPDATED = 'QUESTIONNAIRES_ORIGIN_UPDATED';
export const KIOSK_QUESTIONNAIRES_FILTERED = 'KIOSK_QUESTIONNAIRES_FILTERED';
